module.exports = __webpack_public_path__ + "media/images/teams/BRESCIA-e05532852aa1fd3435cf9c46b2aaafb3.png";